import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import Body from "./Components/Body"
import { Sponsors } from "./Components/Sponsors"


function App() {
  return (
    <div className="App">
      {/* <Navbar /> */}
      {/* <Body /> */}
    <Sponsors />
    </div>
  );
}

export default App;
